/**
 *  Redirige vers la home si utilisateur pro
 */
import { useClientStore } from "@/store/client";

export default defineNuxtRouteMiddleware(() => {

  const { $pinia } = useNuxtApp();
  const clientStore = useClientStore($pinia);

  if (clientStore.isPro) {
    return navigateTo("/", { replace: true });
  }

  return;
})
